import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocationsSelectedCounter = createSelector(
  [(store: RootState) => store.formSubmittedSlice.selectedLocations],
  // Devuelve el listado de locations seleccionados o asignados
  (data) => data.length
);
